import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Reader } from '@thiememeulenhoff/types';
import { ReadersEndpointService } from './readers.endpoint.service';

@Service()
export class ReadersService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(ReadersEndpointService);

  fetchReaders(methodCode?: string) {
    return this.#http.get<Array<Reader>>(this.#endpoints.readers(), {
      params: methodCode ? { method: methodCode } : undefined,
    });
  }

  fetchReader(readerId: string) {
    return this.#http.get<Reader>(this.#endpoints.reader(readerId));
  }

  updateReader(
    readerId: string,
    readerTitle: string,
    subTitle: string,
    schoolName: string,
    description: string,
  ) {
    return this.#http.put(this.#endpoints.updateReader(readerId), {
      title: readerTitle,
      subTitle,
      schoolName,
      description,
    });
  }

  publishReader(readerId: string) {
    return this.#http.post(this.#endpoints.publishReader(readerId), {});
  }

  archiveReader(readerId: string) {
    return this.#http.post(this.#endpoints.archiveReader(readerId), {});
  }

  recoverReader(readerId: string) {
    return this.#http.post(this.#endpoints.recoverReader(readerId), {});
  }

  deleteReader(readerId: string) {
    return this.#http.delete(this.#endpoints.deleteReader(readerId));
  }
}
